import RegularNodeBody from './Assets/nodes/RegularNode_body.png';
import RegularNodeTitleGloss from './Assets/nodes/RegularNode_title_gloss.png';
import RegularNodeTitleHightlight from './Assets/nodes/RegularNode_title_highlight.png';
import RegularNodeShadow from './Assets/nodes/RegularNode_shadow.png';
import RegularNodeShadowSelected from './Assets/nodes/RegularNode_shadow_selected.png';
import RegularNodeColorSpill from './Assets/nodes/RegularNode_color_spill.png';

import VarNodeBody from './Assets/nodes/VarNode_body.png';
import VarNodeGloss from './Assets/nodes/VarNode_gloss.png';
import VarNodeShadow from './Assets/nodes/VarNode_shadow.png';
import VarNodeShadowSelected from './Assets/nodes/VarNode_shadow_selected.png';
import VarNodeColorSpill from './Assets/nodes/VarNode_color_spill.png';

import MathNodeBody from './Assets/nodes/MathNode_body.png';
import MathNodeShadowSelected from './Assets/nodes/MathNode_shadow_selected.png';

import CommentNodeBackground from './Assets/nodes/Comment_Background.png';

import Selector from './Assets/Selector.png';


import EventNodeIcon from './Assets/icons/event.png';
import EventNodeIconCustom from './Assets/icons/event_custom.png';

import MouseEventIcon from './Assets/nodes_icons/icon_Blueprint_MouseEvent_16x.png';
import KeyboardEventIcon from './Assets/nodes_icons/icon_Blueprint_KeyboardEvent_16x.png';

import DelegatePinConnected from './Assets/nodes/DelegatePin_Connected.png';
import DelegatePinDisconnected from './Assets/nodes/DelegatePin_Disconnected.png';

import ExecPinConnected from './Assets/nodes/ExecPin_Connected.png';
import ExecPinDisconnected from './Assets/nodes/ExecPin_Disconnected.png';

import PinConnected from './Assets/nodes/Pin_connected_VarA.png';
import PinDisconnected from './Assets/nodes/Pin_disconnected_VarA.png';

import BranchIcon from "./Assets/nodes_icons/icon_Blueprint_Branch_16x.png";
import MakeStructIcon from "./Assets/nodes_icons/icon_Blueprint_MakeStruct_16x.png";
import BreakStructIcon from "./Assets/nodes_icons/icon_Blueprint_BreakStruct_16x.png";
import EventIcon from "./Assets/nodes_icons/icon_Blueprint_Event_16x.png";
import ForEachIcon from "./Assets/nodes_icons/icon_Blueprint_ForEach_16x.png";
import ForLoopIcon from "./Assets/nodes_icons/icon_Blueprint_Loop_16x.png";
import MakeArrayIcon from "./Assets/nodes_icons/icon_Blueprint_MakeArray_16x.png";
import FlipFlopIcon from "./Assets/nodes_icons/icon_Blueprint_FlipFlop_16x.png";
import DynamicCastIcon from "./Assets/nodes_icons/icon_Blueprint_Cast_16x.png";
import TimelineIcon from "./Assets/nodes_icons/icon_Blueprint_Timeline_16x.png";
import NodeIcon from "./Assets/nodes_icons/icon_Blueprint_Node_16x.png";
import MessageIcon from "./Assets/nodes_icons/MessageIcon.png";
import LatentIcon from "./Assets/nodes_icons/LatentIcon.png";
import ValidIcon from "./Assets/nodes_icons/icon_Blueprint_IsValid_16x.png";
import SelectIcon from "./Assets/nodes_icons/icon_Blueprint_Select_16x.png";
import SequenceIcon from "./Assets/nodes_icons/icon_Blueprint_Sequence_16x.png";
import MacroIcon from "./Assets/nodes_icons/icon_Blueprint_Macro_16x.png";
import SwitchOnIcon from "./Assets/nodes_icons/icon_Blueprint_Switch_16x.png";
import FullscreenIcon from "./Assets/nodes_icons/LV_FullScreen.png";
import SaveIcon from "./Assets/nodes_icons/LV_Save.png";
import FunctionIcon from "./Assets/icons/function.png";



export const TEXTURES = {
    RegularNodeBody: RegularNodeBody,
    RegularNodeTitleGloss: RegularNodeTitleGloss,
    RegularNodeTitleHightlight: RegularNodeTitleHightlight,
    RegularNodeShadow: RegularNodeShadow,
    RegularNodeShadowSelected: RegularNodeShadowSelected,
    RegularNodeColorSpill: RegularNodeColorSpill,
    VarNodeBody: VarNodeBody,
    VarNodeGloss: VarNodeGloss,
    VarNodeShadow: VarNodeShadow,
    VarNodeShadowSelected: VarNodeShadowSelected,
    VarNodeColorSpill: VarNodeColorSpill,
    MathNodeBody: MathNodeBody,
    MathNodeShadowSelected: MathNodeShadowSelected,
    CommentNodeBackground: CommentNodeBackground,
    Selector: Selector,
    DelegatePinConnected: DelegatePinConnected,
    DelegatePinDisconnected: DelegatePinDisconnected,
    ExecPinConnected: PinConnected,
    ExecPinDisconnected: PinDisconnected,
    PinConnected: PinConnected,
    PinDisconnected: PinDisconnected
}

export const ICONS = {
    EventNodeIcon: EventNodeIcon,
    EventNodeIconCustom: EventNodeIconCustom,
    MouseEventIcon: MouseEventIcon,
    KeyboardEventIcon: KeyboardEventIcon,
    BranchIcon: BranchIcon,
    MakeStructIcon: MakeStructIcon,
    BreakStructIcon: BreakStructIcon,
    EventIcon: EventIcon,
    ForEachIcon: ForEachIcon,
    ForLoopIcon: ForLoopIcon,
    MakeArrayIcon: MakeArrayIcon,
    FlipFlopIcon: FlipFlopIcon,
    DynamicCastIcon: DynamicCastIcon,
    TimelineIcon: TimelineIcon,
    NodeIcon: NodeIcon,
    MessageIcon: MessageIcon,
    LatentIcon: LatentIcon,
    ValidIcon: ValidIcon,
    SelectIcon: SelectIcon,
    SequenceIcon: SequenceIcon,
    MacroIcon: MacroIcon,
    SwitchOnIcon: SwitchOnIcon,
    FullscreenIcon: FullscreenIcon,
    SaveIcon: SaveIcon,
    FunctionIcon: FunctionIcon
}


// WEBPACK FOOTER //
// ./src/resources.js